// used for now as a way to distinguish between interior vs exterior components stores in the same wall.items list.
export enum ComponentSurfaceType {
  InteriorSurface = 'interior-surface',
  ExteriorSurface = 'exterior-surface',
}
